import { dashboardMock } from "../../../src/config/data/mocks";

/**
 *
 */
const cleanFilters = (filters, method = 'post') => ({
  defined: true,
  userid: filters.userId,
  //dateFrom: moment(filters.dateFrom).valueOf(),
  //dateTo: moment(filters.dateTo).valueOf(),
  dateFrom: filters.dateFrom,
  dateTo: filters.dateTo,
  clusterInclude: filters.clusterInclude ? filters.clusterInclude : undefined,
  logicalLocationInclude: filters.logicalLocationInclude ? filters.logicalLocationInclude : undefined,
  geoLocationInclude: filters.geoLocationInclude ? filters.geoLocationInclude : undefined,
  criticalMomentInclude: filters.criticalMomentInclude ? filters.criticalMomentInclude : undefined,
  groupBy: filters.groupBy ? filters.groupBy : undefined,
  tag: filters.tag ? filters.tag : undefined,
})

export const dashboardApi = (api) => ({
  getData: (url, filters) => {
    return api['get'](url, { ...cleanFilters(filters, 'get') })
  },
})

const createPromise = payload => Promise.resolve({
  data: payload.data,
  ok: true
});

const createPromiseSingle = payload => Promise.resolve({
  data: payload.data[0],
  ok: true
});

export const dashboardApiMock = () => ({
  getData: (url, filters) => {
    const mocks = dashboardMock;
    const groupBy = filters.groupBy;
    switch (url) {
      case "survey-responses/counters":
        return createPromiseSingle(mocks.alerts);
      case "indicators/nps/values":
        return createPromiseSingle(groupBy ? mocks.npsHist : mocks.nps);
      case "indicators/satisfaction/values":
        return createPromiseSingle(groupBy ? mocks.satisfactionHist : mocks.satisfaction);
      case "indicators/sampler-offer/values":
        return createPromiseSingle(groupBy ? mocks.offerSamplerHist : mocks.offerSampler);
      case "indicators/willingness-to-return/values":
        return createPromiseSingle(groupBy ? mocks.willingnessToReturnHist : mocks.willingnessToReturn);
      case "indicators/environment/values":
        return createPromiseSingle(mocks.environment);
      case "indicators/drink/values":
        return createPromiseSingle(mocks.drink);
      case "indicators/food/values":
        return createPromiseSingle(mocks.food);
      case "indicators/service/values":
        return createPromiseSingle(mocks.service);
      case "indicators/willingness-to-recommend/values":
        return createPromiseSingle(groupBy ? mocks.willingnessToRecommendHist : mocks.willingnessToRecommend);
      case "indicators/sentiment/values":
        return createPromise(mocks.sentimentAnalysis);
      case "indicators/sentiment-comments/values":
        return createPromiseSingle(mocks.sentimentComments);
      case "indicators/comments/values":
        return createPromise(mocks.lastComments);
      case "indicators/general-xp/values":
        return createPromiseSingle(groupBy ? mocks.experienceHist : mocks.experience);
      default:
        return { data: {}, ok: false };
    }
  }
});



// WEBPACK FOOTER //
// ./src/services/api/DashboardApi.js